const customStyles = {
  header: {
    style: {
      height: '68px',
      flexWrap: 'nowrap',
      // "Title" Section
      '> div:nth-of-type(1)': {
        flexShrink: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      // "Actions" Section
      '> div:nth-of-type(2)': {
        flexShrink: 0,
      },
    },
  },
  rows: {
    style: {
      '&:first-of-type': {
        height: '72px',
      },
      '&:last-of-type': {
        height: '54px',
      },
    },
  },
  cells: {
    style: {
      '&:first-of-type': {
        width: '128px',
        maxWidth: '128px',
      },
    },
  },
};

export default customStyles;
